import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { AdminReportSystemErrorLogsComponent } from './admin-reports.system-error-logs.component';

angular.module('app-lite.admin-reports', [])
  .directive('worAdminReportsSystemErrorLogs', downgradeComponent({ component: AdminReportSystemErrorLogsComponent }));
